import { c as _c } from "react/compiler-runtime";
import { AnalyticsSkuViewed } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed';
import customImageWidthURLBuilder from '@cc-shopping/utils/custom-image-width-url-builder';
import { Box } from '@mui/material';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import ReviewApplyNow from 'src/app/credit-cards/reviews/components/Footer/ApplyNow';
import { RatesAndFeesLink } from 'src/features/product-card/RatesAndFeesLink';
import { PictureLink } from './PictureLink';
export default function MiniProductCard() {
  const $ = _c(33);
  const {
    marketplaceEntity
  } = useReviewContext();
  const {
    image: t0,
    analytics: t1,
    ctaAnalytics,
    id,
    displayName,
    institution,
    product,
    showCTA,
    termsAndFeesLink,
    versionId,
    name
  } = marketplaceEntity;
  const {
    resizable: resizableImage,
    medium: mediumImage
  } = t0;
  const {
    monetizable,
    offerId
  } = t1;
  let t2;
  if ($[0] !== mediumImage.url || $[1] !== mediumImage.width || $[2] !== resizableImage) {
    t2 = customImageWidthURLBuilder(resizableImage, {
      customImageWidth: mediumImage.width,
      customImageQuality: 100,
      imageParentWidth: 160
    }, mediumImage.url);
    $[0] = mediumImage.url;
    $[1] = mediumImage.width;
    $[2] = resizableImage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    optimized
  } = t2;
  if (!showCTA) {
    return null;
  }
  let t3;
  if ($[4] !== optimized.image.url) {
    t3 = <PictureLink url={optimized.image.url} />;
    $[4] = optimized.image.url;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== optimized.parentElement.height || $[7] !== optimized.parentElement.width || $[8] !== t3) {
    t4 = <Box display="flex" height={optimized.parentElement.height} width={optimized.parentElement.width} position="relative" alignItems="center">{t3}</Box>;
    $[6] = optimized.parentElement.height;
    $[7] = optimized.parentElement.width;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ReviewApplyNow />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== ctaAnalytics || $[12] !== displayName || $[13] !== name || $[14] !== termsAndFeesLink || $[15] !== versionId) {
    t6 = termsAndFeesLink && <RatesAndFeesLink analytics={{
      ...ctaAnalytics,
      section: {
        ...ctaAnalytics.section,
        name: "review_how_to_decide"
      },
      linkType: "RATES_AND_FEES_TEXT"
    }} href={termsAndFeesLink} versionId={versionId} additionalParams={{
      monetizable: ctaAnalytics.monetizable
    }} showBlankTargetIcon={true} name={displayName || name} />;
    $[11] = ctaAnalytics;
    $[12] = displayName;
    $[13] = name;
    $[14] = termsAndFeesLink;
    $[15] = versionId;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== optimized.parentElement.width || $[18] !== t6) {
    t7 = <Box display="flex" width={optimized.parentElement.width} position="relative" alignItems="center" flexDirection="column">{t5}{t6}</Box>;
    $[17] = optimized.parentElement.width;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t4 || $[21] !== t7) {
    t8 = <Box display="flex" flexDirection="column" alignItems="center" gap={2}>{t4}{t7}</Box>;
    $[20] = t4;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== displayName || $[24] !== id || $[25] !== institution.id || $[26] !== institution.name || $[27] !== monetizable || $[28] !== offerId || $[29] !== product.id || $[30] !== product.name || $[31] !== t8) {
    t9 = <AnalyticsSkuViewed id={id} impressionSection="review_how_to_decide" impressionPosition={0} institutionId={institution.id} institutionName={institution.name} key={id} monetizable={monetizable} name={displayName} offerId={offerId} offerName={displayName} productId={product.id} productName={product.name}>{t8}</AnalyticsSkuViewed>;
    $[23] = displayName;
    $[24] = id;
    $[25] = institution.id;
    $[26] = institution.name;
    $[27] = monetizable;
    $[28] = offerId;
    $[29] = product.id;
    $[30] = product.name;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
}